jQuery(function($) {
    let cookieyes_consent = cookieyes_choice();
    $('#cookie_choice').on('click', function(event){
        event.preventDefault();
        if(cookieyes_consent === 'yes') {
            performBannerAction('reject');
            cookieyes_consent = 'no'
            switch_cookieyes_no();
        }
        else {
            performBannerAction('accept_all');
            cookieyes_consent = 'yes'
            switch_cookieyes_yes();
        }
    });
    $('body').on('click', '.cky-btn-reject', function() {
        cookieyes_consent = 'no'
        switch_cookieyes_no();
    });    
    $('body').on('click', '.cky-btn-accept', function() {
        cookieyes_consent = 'yes'
        switch_cookieyes_yes();
    });

    function cookieyes_choice() {
        let cookies = document.cookie.split(';');
        for (let cookie of cookies) {
            let [name, value] = cookie.split('=').map(cookieitem => cookieitem.trim());
            if (name && value && name === 'cookieyes-consent') {
                if (value.includes('consent:yes')) {
                    switch_cookieyes_yes();
                    return 'yes';
                }
                else {
                    switch_cookieyes_no();
                    return 'no';
                }
            }
        }
        switch_cookieyes_no();
        return 'no';
    }

    function switch_cookieyes_no() {
        $('#cookie_choice').text('Do Not Sell or Share My Personal Information is activated');
    }
    function switch_cookieyes_yes() {
        $('#cookie_choice').text('Do Not Sell or Share My Personal Information');
    }

}); 